import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
  HubConnectionState,
  LogLevel,
} from '@microsoft/signalr';
import { NotificationsService } from '../notifications.service';
import { HUB_URL } from '../../utils';

@Injectable({
  providedIn: 'root',
})
export class SignalRService extends NotificationsService {
  private hubConnection!: HubConnection;
  private currentToken: string | null = null;

  notifications: WritableSignal<NotificationI[]> = signal([]);

  hubUrl = inject(HUB_URL);

  constructor() {
    super();
  }

  setToken(token: string | null): void {
    this.currentToken = token;
  }

  startConnection(): void {
    if (
      this.hubConnection?.state === HubConnectionState.Connected ||
      this.hubConnection?.state === HubConnectionState.Connecting
    ) {
      return;
    }

    if (!this.currentToken) {
      return;
    }

    this.hubConnection = new HubConnectionBuilder()
      .withUrl(`${this.hubUrl}/hubs/notifications`, {
        accessTokenFactory: () => this.currentToken ?? '',
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets,
      })
      .configureLogging(LogLevel.None)
      .withAutomaticReconnect()
      .build();

    this.hubConnection.on(
      'ReceiveNotification',
      (message: NotificationI[] | NotificationI) => {
        if (Array.isArray(message)) {
          this.notifications.update((values) => [...values, ...message]);
        } else {
          this.notifications.set([message]);
        }
      }
    );

    this.hubConnection
      .start()
      .catch((err: any) =>
        console.error('Error while starting SignalR connection: ', err)
      );
  }

  destroyConnection(): void {
    if (this.hubConnection) {
      this.hubConnection
        .stop()
        .catch((err: any) =>
          console.error('Error while stopping SignalR connection:', err)
        );
    }
  }
}

export interface NotificationI {
  id: string;
  message: string;
}
